import { render, staticRenderFns } from "./LoanStatus.vue?vue&type=template&id=15937625&scoped=true&"
import script from "./LoanStatus.vue?vue&type=script&lang=js&"
export * from "./LoanStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15937625",
  null
  
)

export default component.exports